export default {
  umamiGold: '#CFC87B',
};
